import React from 'react'
import { Col, Form, Button, Container } from 'react-bootstrap'
import {FiSearch} from "react-icons/fi"
function SearchContainer({displayState}) {
    return (
        <Container className="my-4" style={{dispaly: displayState}}>
          {console.log(displayState)}
            <Form>
  <Form.Group className="mb-3 mx-auto d-flex border border-secondary" >
    <Form.Control type="text" placeholder="Search For Anything..." />
    
  <Button  variant="secondary" type="submit" className="w-25" style={{borderRadius: "unset"}}>
    Search
  </Button>
  </Form.Group>
</Form>
        </Container>
    )
}

export default SearchContainer
